module.exports = __webpack_public_path__ + "img/Avatar-15.7d606fca.gif";